import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]返回资管专区产品列表
 */
export function getProductListUsingPOST(
  req: AssetsManageDto | void,
  config?: RequestConfig
): Promise<ApiResultListAssetsManageParam> {
  return resource.postNoAuth('/api/assetsManage/productList', req, config);
}

/**
 * [No Auth]返回类型列表
 */
export function getTypeListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultSetAssetsManageType> {
  return resource.postNoAuth('/api/assetsManage/typeList', req, config);
}
